module.exports = __webpack_public_path__ + "static/media/checkmarkRed.806f14c3.svg";